<template>
  <div class="container is-multiline" v-if="$store.state.evaluation && $store.getters.session">
    <div v-sticky="{ zIndex: 10, stickyTop: 55, disabled: false }" ref="Dashboard"
         v-if="!$store.state.isPdf && localEvaluationDashboardSettings.showDashboard">
      <div class="container is-fluid content is-size-7 dashboard">
        <div class="columns">
          <div class="column">
            <span>
              <div class="has-text-weight-bold">
                <i class="fas fa-helicopter"></i> Jump to...
              </div>
              <div>
                <a class="dashboard-link" @click="scrollMeTo('PropertyEvaluation')">Property Evaluation</a>
              </div>
              <div>
                <a class="dashboard-link" @click="scrollMeTo('SaleComparables')">Sale Comparables</a>
              </div>
              <div>
                <a class="dashboard-link" @click="scrollMeTo('RentComparables')">Rent Comparables</a>
              </div>
              <div>
                <a class="dashboard-link" @click="scrollMeTo('CashFlowAnalysis')">Cash Flow Analysis</a>
              </div>
            </span>
          </div>

          <div class="column" v-if="!isNarrow">
            <div class="has-text-weight-bold">
              {{ $store.state.property.address }}
            </div>
            <div class="">
              {{ $store.state.property.city }}
              {{ $store.state.property.state }}, {{ $store.state.property.zip }}
            </div>
            <i class="fas fa-bed"></i>
            {{ $store.state.evaluation.beds }}
            <i class="fas fa-bath"></i>
            {{ $store.state.evaluation.baths }}
            <i class="fas fa-car"></i>
            {{ $store.state.evaluation.garage }} |
            {{ $store.state.evaluation.sqft | number(0) }} sqft |
            {{ $store.state.evaluation.yearBuilt }} built
            <div class="">
              {{ $store.state.property.subdivision }}
            </div>
            <div class="is-divider" style="margin: 10px"></div>

            <nav class="level">
              <div class="level-item has-text-centered">
                <div>
                  <span class="heading">Sale Price</span>
                  <b-tooltip label="This is the Average Price per Sqft times the Subject Property Sqft."
                             position="is-top">
                    <p class="is-size-5 has-text-weight-semibold">
                      {{
                        $store.state.evaluation.saleCompGroup.calculatedValue
                            | currency(0)
                      }}
                    </p>
                  </b-tooltip>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <span class="heading">Rent Price</span>
                  <b-tooltip label="This is the Average Price per Sqft times the Subject Property Sqft."
                             position="is-top">
                    <p class="is-size-5 has-text-weight-semibold">
                      {{
                        $store.state.evaluation.rentCompGroup.calculatedValue
                            | currency(0)
                      }}
                    </p>
                  </b-tooltip>
                </div>
              </div>
            </nav>
          </div>

          <div class="column" v-if="
          	$store.state.evaluation.calculator.conventionalInputs.show &&
          	!isNarrow
          ">
            <!-- <table> -->
            <tr>
              <div class="has-text-weight-bold">Conventional</div>
            </tr>
            <tr>
              <td>Equity capture</td>
              <td class="has-text-right has-text-weight-semibold">
                {{
                  $store.state.evaluation.calculator
                      .conventionalUnrealizedCapitalGain | currency(0)
                }}
              </td>
            </tr>
            <tr>
              <td>Annual cash flow</td>
              <td class="has-text-right has-text-weight-semibold">
                {{
                  $store.state.evaluation.calculator.conventionalAnnualCashFlow
                      | currency(0)
                }}
              </td>
            </tr>
            <tr>
              <td>Return on equity capture</td>
              <td class="has-text-right has-text-weight-semibold">
                {{
                  $store.state.evaluation.calculator
                      .conventionalReturnOnCapitalGainPercent | percent(0)
                }}
              </td>
            </tr>
            <tr>
              <td>Cash on cash return</td>
              <td class="has-text-right has-text-weight-semibold">
                {{
                  $store.state.evaluation.calculator
                      .conventionalCashOnCashReturnPercent | percent(1)
                }}
              </td>
            </tr>
            <!-- </table> -->
          </div>

          <div class="column" v-if="
          	$store.state.evaluation.calculator.hardMoneyInputs.show &&
          	!isNarrow
          ">
            <!-- <table> -->
            <tr>
              <div class="has-text-weight-bold">Hard Money</div>
            </tr>
            <tr>
              <td>Equity capture</td>
              <td class="has-text-right has-text-weight-semibold">
                {{
                  $store.state.evaluation.calculator.hardUnrealizedCapitalGain
                      | currency(0)
                }}
              </td>
            </tr>
            <tr>
              <td>Annual cash flow</td>
              <td class="has-text-right has-text-weight-semibold">
                {{
                  $store.state.evaluation.calculator.hardAnnualCashFlow
                      | currency(0)
                }}
              </td>
            </tr>
            <tr>
              <td>Return on equity capture</td>
              <td class="has-text-right has-text-weight-semibold">
                {{
                  $store.state.evaluation.calculator
                      .hardReturnOnCapitalGainPercent | percent(0)
                }}
              </td>
            </tr>
            <tr>
              <td>Cash on cash return</td>
              <td class="has-text-right has-text-weight-semibold">
                {{
                  $store.state.evaluation.calculator.hardCashOnCashReturnPercent
                      | percent(1)
                }}
              </td>
            </tr>
            <!-- </table> -->
          </div>

          <div class="column is-narrow">
            <tr>
              <b-switch v-model="localEvaluationDashboardSettings.showDashboard" @input="saveEvaluationDashboardSettings">Show Dashboard</b-switch>
            </tr>
            <tr>
              <b-switch v-model="localEvaluationDashboardSettings.showDetails" @input="saveEvaluationDashboardSettings">Show Property Details</b-switch>
            </tr>
            <tr>
              <b-switch v-model="localEvaluationDashboardSettings.showSaleComps" @input="saveEvaluationDashboardSettings">Show Sale Comps</b-switch>
            </tr>
            <tr>
              <b-switch v-model="localEvaluationDashboardSettings.showRentComps" @input="saveEvaluationDashboardSettings">Show Rent Comps</b-switch>
            </tr>
            <tr>
              <b-switch v-model="localEvaluationDashboardSettings.showCalculator" @input="saveEvaluationDashboardSettings">Show Calculator</b-switch>
            </tr>
          </div>
        </div>
      </div>
    </div>

    <p v-if="$store.state.isPdf">
      Created by {{ $store.getters.session.user.firstName }}
      {{ $store.getters.session.user.lastName }} on
      {{ new Date() | dateMediumTime() }}
    </p>
    <div v-if="localEvaluationDashboardSettings.showDetails">
      <div class="card" ref="PropertyEvaluation">
        <section class="hero is-primary">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">Property Evaluation</h1>
            </div>
          </div>
        </section>
      </div>
      <div class="card">
        <div class="card-header">
          <div class="card-header-title">Property Details</div>
          <div class="level-right is-small">
            <b-switch size="is-small" v-model="localEvaluationDashboardSettings.showDashboard"  @input="saveEvaluationDashboardSettings" style="padding-right: 20px">Show Dashboard</b-switch>
            |
            <a @click="goToProperty()" style="padding-left: 20px">
              <i class="fas fa-arrow-left"></i>
              return to property&nbsp;&nbsp;</a>
          </div>
        </div>
        <div class="card-content">
          <article class="media">
            <figure class="media-left">
              <p class="image is-128x128">
                <img :src="$store.state.property.photoUrl"/>
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <div class="columns">
                  <div class="column">
                    <p>
                      <strong class="is-size-4">{{
                          $store.state.property.address
                        }}</strong><br/>
                      <small>{{ $store.state.property.city }},
                        {{ $store.state.property.state }}
                        {{ $store.state.property.zip }}</small>
                      <br/>
                      <small>{{ $store.state.evaluation.subdivision }}</small>
                      <br/>
                      <small>{{
                          $store.state.property.lastUpdate | fromNow
                        }}</small>
                    </p>
                  </div>
                  <div class="column">
                    <i class="fas fa-bed"></i>
                    {{ $store.state.evaluation.beds }}
                    <i class="fas fa-bath"></i>
                    {{ $store.state.evaluation.baths }}
                    <i class="fas fa-car"></i>
                    {{ $store.state.evaluation.garage }}
                    <b-tooltip label="Edit property attributes">
                      <a class="fas fa-edit" style="padding-left: 10px" @click="editPropertyAttributes()"></a>
                    </b-tooltip>
                    <div>
                      {{ $store.state.evaluation.sqft | number(0) }} sqft
                    </div>
                    <div>{{ $store.state.evaluation.yearBuilt }} built</div>
                    <div v-if="
                    	$store.state.evaluation.compDataSource == 'Discovery'
                    ">
                      {{ $store.state.evaluation.taxesAnnual | currency(0) }}
                      annual tax
                    </div>
                  </div>
                  <div class="column" v-if="!$store.state.isPdf"></div>
                </div>
              </div>
            </div>
            <div class="media-right">
              <div class="level-right">
                <a class="level-item">
                  <span class="icon is-small">
                    <i v-if="$store.state.property.photoUrls.length > 0" class="fas fa-camera"
                       @click="isPhotosOpen = !isPhotosOpen"></i>
                  </span>
                </a>
              </div>
            </div>
          </article>

          <nav class="level" v-if="$store.state.evaluation.compDataSource != 'Discovery'">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">List</p>
                <p class="subtitle">
                  {{ $store.state.evaluation.listPrice | currency(0) }}
                </p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Price per Sqft</p>
                <p class="subtitle">
                  {{
                    ($store.state.evaluation.listPrice /
                        $store.state.evaluation.sqft)
                        | currency(0)
                  }}
                </p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Market</p>
                <p class="subtitle">{{ $store.state.evaluation.mlsMarket }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Listing Provided By</p>
                <p class="subtitle">{{ $store.state.evaluation.listingOfficeName }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">MLS #</p>
                <p class="subtitle">{{ $store.state.evaluation.mlsNumber }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Taxes</p>
                <p class="subtitle">
                  {{ $store.state.evaluation.taxesAnnual | currency(0) }}
                </p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">HOA</p>
                <p class="subtitle">
                  {{ $store.state.evaluation.hoaAnnual | currency(0) }}
                </p>
              </div>
            </div>
          </nav>

          <b-collapse :open="isPhotosOpen">
            <div class="notification">
              <div class="container is-fluid">
                <div class="columns is-multiline">
                  <div class="column is-one-third" v-for="photoUrl in $store.state.property.photoUrls" :key="photoUrl">
                    <figure class="image is-3by2">
                      <img v-bind:src="photoUrl"/>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="card-header-title">Evaluation Notes</div>
        </div>
        <div class="card-content">
          <div v-html="$store.state.evaluation.notes"></div>
          <div class="level-left">
            <span class="link">
              <b-tooltip label="Edit" position="is-bottom">
                <a class="fas fa-edit" @click="isEditNoteActive = true"></a>
              </b-tooltip>
            </span>
          </div>
        </div>

        <b-modal :active.sync="isEditNoteActive" has-modal-card :canCancel="[]">
          >
          <EditNote/>
        </b-modal>
      </div>
    </div>
    <div v-if="localEvaluationDashboardSettings.showSaleComps">
      <div class="card" ref="SaleComparables">
        <section class="hero is-info">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">Sale Comparables</h1>
            </div>
          </div>
        </section>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="card-header-title">Search</div>
        </div>
        <div class="card-content" style="background-color: #ffffdd">
          <SaleCompFilter/>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="card-header-title">Matching Sales</div>
        </div>
        <div class="card-content">
          <SaleCompList/>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="card-header-title">Sale Price</div>
        </div>
        <div class="card-content">
          <SaleCompSummary/>
        </div>
      </div>

      <div class="card" v-if="$store.state.evaluation.saleCompGroup.trends.length > 0">
        <div class="card-header">
          <div class="card-header-title">Price Trend</div>
        </div>
        <div class="card-content">
          <SaleCompTrends/>
        </div>
      </div>
    </div>

    <div v-if="localEvaluationDashboardSettings.showRentComps">
      <div class="card" ref="RentComparables">
        <section class="hero is-info">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">Rent Comparables</h1>
            </div>
          </div>
        </section>
      </div>

      <div class="card" v-if="!isRentRange()">
        <div class="card-header">
          <div class="card-header-title">Search</div>
        </div>
        <div class="card-content" style="background-color: #ffffdd">
          <RentCompFilter/>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="card-header-title">
            Matching Rents
            <img v-if="isRentRange()" style="margin-left: 1em" src="@/assets/rr_logo.png" width="100px"/>
          </div>
        </div>
        <div class="card-content" v-if="isRentRangeFail() != ''">
          <b-button class="button is-danger" @click="editPropertyAttributes()">{{ isRentRangeFail() }}</b-button>
        </div>
        <div class="card-content">
          <RentCompList/>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="card-header-title">Rent Price</div>
        </div>
        <div class="card-content">
          <RentCompSummary/>
        </div>
      </div>

      <div class="card" v-if="$store.state.evaluation.rentCompGroup.trends.length > 0">
        <div class="card-header">
          <div class="card-header-title">Price Trend</div>
        </div>
        <div class="card-content">
          <RentCompTrends/>
        </div>
      </div>
    </div>

    <div v-if="localEvaluationDashboardSettings.showCalculator">
      <div class="card" ref="CashFlowAnalysis">
        <section class="hero is-info">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">Cash Flow Analysis</h1>
            </div>
          </div>
        </section>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="card-header-title">Deal terms, expenses, revenue</div>
        </div>
        <div class="card-content" style="background-color: #ffffdd">
          <CashFlowDealTerms/>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="card-header-title">Conventional Financing</div>
        </div>
        <div class="card-content">
          <div class="tile is-ancestor">
            <div class="tile is-3">
              <div class="card">
                <div class="card-content is-marginless is-paddingless">
                  <ConventionalFinancing/>
                </div>
              </div>
            </div>

            <div class="tile is-9">
              <div class="container is-fluid">
                <div class="columns is-multiline">
                  <div class="column">
                    <div class="card" v-if="
                    	$store.state.evaluation.calculator.conventionalInputs
                    		.show
                    ">
                      <div class="card-header has-text-weight-bold">
                        <div class="
														columns
														is-centered
														column
														subtitle
														has-text-weight-semibold
													">
                          Gains And Returns
                        </div>
                      </div>
                      <div class="card-content">
                        <ConventionalGainsAndReturns/>
                      </div>
                    </div>
                  </div>

                  <div class="column">
                    <div class="card" v-if="
                    	$store.state.evaluation.calculator.conventionalInputs
                    		.show
                    ">
                      <div class="card-header has-text-weight-bold">
                        <div class="
														columns
														is-centered
														column
														subtitle
														has-text-weight-semibold
													">
                          Cash Out Of Pocket
                        </div>
                      </div>
                      <div class="card-content">
                        <ConventionalCashOutOfPocket/>
                      </div>
                    </div>
                  </div>

                  <div class="column">
                    <div class="card" v-if="
                    	$store.state.evaluation.calculator.conventionalInputs
                    		.show
                    ">
                      <div class="card-header has-text-weight-bold">
                        <div class="
														columns
														is-centered
														column
														subtitle
														has-text-weight-semibold
													">
                          Cash Flow
                        </div>
                      </div>
                      <div class="card-content">
                        <ConventionalCashFlow/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="card-header-title">Hard Money Financing</div>
        </div>
        <div class="card-content">
          <div class="tile is-ancestor">
            <div class="tile is-3">
              <div class="card">
                <div class="card-content is-marginless is-paddingless">
                  <HardFinancing/>
                </div>
              </div>
            </div>

            <div class="tile is-9">
              <div class="container is-fluid">
                <div class="columns is-multiline">
                  <div class="column">
                    <div class="card" v-if="
                    	$store.state.evaluation.calculator.hardMoneyInputs.show
                    ">
                      <div class="card-header has-text-weight-bold">
                        <div class="
														columns
														is-centered
														column
														subtitle
														has-text-weight-semibold
													">
                          Gains And Returns
                        </div>
                      </div>
                      <div class="card-content">
                        <HardGainsAndReturns/>
                      </div>
                    </div>
                  </div>

                  <div class="column" v-if="
                  	$store.state.evaluation.calculator.hardMoneyInputs.show
                  ">
                    <div class="card">
                      <div class="card-header has-text-weight-bold">
                        <div class="
														columns
														is-centered
														column
														subtitle
														has-text-weight-semibold
													">
                          Cash Out Of Pocket
                        </div>
                      </div>
                      <div class="card-content">
                        <HardCashOutOfPocket/>
                      </div>
                    </div>
                    <tr>
                      <td>*</td>
                      <td>Check with your lender on cashback limits</td>
                    </tr>
                  </div>

                  <div class="column">
                    <div class="card" v-if="
                    	$store.state.evaluation.calculator.hardMoneyInputs.show
                    ">
                      <div class="card-header has-text-weight-bold">
                        <div class="
														columns
														is-centered
														column
														subtitle
														has-text-weight-semibold
													">
                          Cash Flow
                        </div>
                      </div>
                      <div class="card-content">
                        <HardCashFlow/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="page_finished" class="page_finished">&nbsp;</div>

    <b-modal :active.sync="$store.state.propertyAttributeEdit.isActive" has-modal-card :canCancel="[]">
      <EditPropertyAttributes/>
    </b-modal>
  </div>
</template>
<script>
import SaleCompFilter from "@/components/properties/evaluations/SaleCompFilter.vue";
import SaleCompSummary from "@/components/properties/evaluations/SaleCompSummary.vue";
import SaleCompTrends from "@/components/properties/evaluations/SaleCompTrends.vue";
import SaleCompList from "@/components/properties/evaluations/SaleCompList.vue";
import RentCompFilter from "@/components/properties/evaluations/RentCompFilter.vue";
import RentCompSummary from "@/components/properties/evaluations/RentCompSummary.vue";
import RentCompTrends from "@/components/properties/evaluations/RentCompTrends.vue";
import RentCompList from "@/components/properties/evaluations/RentCompList.vue";
import CashFlowDealTerms from "@/components/properties/evaluations/CashFlowDealTerms.vue";
import ConventionalFinancing from "@/components/properties/evaluations/ConventionalFinancing.vue";
import ConventionalGainsAndReturns from "@/components/properties/evaluations/ConventionalGainsAndReturns.vue";
import ConventionalCashFlow from "@/components/properties/evaluations/ConventionalCashFlow.vue";
import ConventionalCashOutOfPocket from "@/components/properties/evaluations/ConventionalCashOutOfPocket.vue";
import HardFinancing from "@/components/properties/evaluations/HardFinancing.vue";
import HardGainsAndReturns from "@/components/properties/evaluations/HardGainsAndReturns.vue";
import HardCashFlow from "@/components/properties/evaluations/HardCashFlow.vue";
import HardCashOutOfPocket from "@/components/properties/evaluations/HardCashOutOfPocket.vue";
import EditNote from "@/components/properties/evaluations/EditNote.vue";
import VueSticky from "vue-sticky";
import Helpers from "@/services/Helpers.js";
import EditPropertyAttributes from "@/components/properties/evaluations/EditPropertyAttributes.vue";
import {mapState} from "vuex";

export default {
  data() {
    return {
      isPhotosOpen: false,
      isEditNoteActive: false,
      isNarrow: Helpers.isMobile() || Helpers.isTablet(),
      localEvaluationDashboardSettings: {
        // showDashboard: false,
        // showDetails: true,
        // showSaleComps: true,
        // showRentComps: true,
        // showCalculator: true
      }
    };
  },

  directives: {
    sticky: VueSticky,
  },

  components: {
    SaleCompFilter,
    SaleCompSummary,
    SaleCompTrends,
    SaleCompList,
    RentCompFilter,
    RentCompSummary,
    RentCompTrends,
    RentCompList,
    CashFlowDealTerms,
    ConventionalFinancing,
    ConventionalGainsAndReturns,
    ConventionalCashFlow,
    ConventionalCashOutOfPocket,
    HardFinancing,
    HardGainsAndReturns,
    HardCashFlow,
    HardCashOutOfPocket,
    EditNote,
    VueSticky,
    Helpers,
    EditPropertyAttributes,
  },

  props: {
    property_id: undefined,
    evaluation_id: undefined,
    session_key: undefined
  },

  methods: {
    isRentRange() {
      if (this.$store.state.evaluation.isRentRange == true) return true;
      else return false;
    },

    isRentRangeFail() {
      if (this.isRentRange()) {
        if (this.$store.state.evaluation.baths == 0)
          return "To see rent comps enter number of bathrooms";
        if (this.$store.state.evaluation.beds == 0)
          return "To see rent comps enter number of bedrooms";
        if (this.$store.state.evaluation.sqft == 0)
          return "To see rent comps enter sqft";
      }
      return "";
    },

    scrollMeTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop - this.$refs["Dashboard"].clientHeight - 4;
      window.scrollTo(0, top);
    },

    goToProperty() {
      this.$router.push({
        name: "PropertyDetails",
        params: {
          property_id: this.$store.state.property.id,
        },
      });
    },

    editPropertyAttributes() {
      console.log("editPropertyAttributes()");
      this.$store.commit("SET_PROPERTY_ATTRIBUTES", true);
    },
    
    saveEvaluationDashboardSettings() {
      this.$store.dispatch("saveEvaluationDashboardSettings", this.localEvaluationDashboardSettings);
    }
  },

  computed: {
    ...mapState(["evaluation", "evaluationDashboardSettings"])
  },
  
  watch: {
    evaluationDashboardSettings() {
      this.localEvaluationDashboardSettings = this.evaluationDashboardSettings;
    }
  },
  
  async mounted() {

    this.$store.dispatch("getEvaluationDashboardSettings");
    if (
        this.$router.currentRoute.name == "EvaluationDetailsStandAlone" ||
        this.$router.currentRoute.name == "EvaluationDetailsPdf"
    )
      this.$store.state.isPdf = true;

    this.$store.commit("SET_IS_EVALUATING", true);

    // If the store doesn't have an evaluation, this is probably being called
    // directly to create a PDF of the evaluation. So we need to get everything
    // set up for the page to load successfully.
    if (this.$store.state.evaluation == "") {
      console.log('no evaluation');
      // Get the URL keys.
      var propertyId = this.property_id;
      var evaluationId = this.evaluation_id;
      var sessionKey = this.session_key;

      // Get the active session.
      if (sessionKey) {
        await this.$store.dispatch("getSession", sessionKey);
      } else if (this.$store.getters.session) {
        await this.$store.dispatch(
            "getSession",
            this.$store.getters.session.sessionKey
        );
      }

      // Get the property.
      console.log("calling getProperty()");
      await this.$store.dispatch("getProperty", propertyId);
      this.property = this.$store.state.property;

      let evaluation = "";

      // Find the evaluation.
      for (var i = 0; i < this.property.evaluations.length; i++) {
        if (this.property.evaluations[i].id == evaluationId)
          evaluation = this.property.evaluations[i];
      }

      if (evaluation != "") this.$store.state.evaluation = evaluation;
      console.log("evaluation", this.$store.state.evaluation);
    } else {
      //Executes when page is navigated to
      var propertyId = this.$store.state.evaluation.propertyId;
      await this.$store.dispatch("getProperty", propertyId);
      this.property = this.$store.state.property;
    }
  }
};
</script>

<style>
.dashboard-link {
  /* color: #0d2f7e; */
  color: #aaaaaa;
}

.dashboard {
  /* background-color: #e0e0e0; */
  background-color: #ffffff;
  opacity: 0.93;
  /* color: #4e4e4e; */
  color: #aaaaaa;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
